module.exports = __webpack_public_path__ + "static/media/mp.2671eebe.svg";